import * as React from 'react'

export const sectionStyle: React.CSSProperties = {
  border: '1px solid #e5e7eb',
  borderRadius: '8px',
  padding: '10px',
  marginTop: '10px',
}

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '6px 8px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  fontSize: '12px',
  boxSizing: 'border-box',
}

const buttonStyle: React.CSSProperties = {
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  background: '#fff',
  padding: '4px 8px',
  fontSize: '12px',
  cursor: 'pointer',
}

export function labelize(name?: string, fallback = '') {
  if (!name) return fallback
  return name
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, s => s.toUpperCase())
    .trim()
}

export function FieldTitle({ title }: { title: string }) {
  return (
    <div
      style={{
        marginBottom: '10px',
        borderRadius: '8px',
        background: '#181818',
        color: '#ffffff',
        fontSize: '12px',
        fontWeight: 600,
        padding: '8px 12px',
      }}
    >
      {title}
    </div>
  )
}

export function SectionTitle({ title }: { title: string }) {
  return <div style={{ fontSize: '12px', fontWeight: 600, marginBottom: '4px' }}>{title}</div>
}

export function SectionHelpText({ text }: { text: string }) {
  return <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '8px' }}>{text}</div>
}

export function FieldLabel({ label, helpText }: { label: string; helpText?: string }) {
  return (
    <div style={{ marginBottom: '4px' }}>
      <div style={{ fontSize: '11px', fontWeight: 500, color: '#374151' }}>{label}</div>
      {helpText && <div style={{ fontSize: '10px', color: '#6b7280' }}>{helpText}</div>}
    </div>
  )
}

export function TextInput(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} style={inputStyle} />
}

export function SelectInput(props: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} style={inputStyle} />
}

export function ActionButton(props: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type="button" {...props} style={buttonStyle} />
}

export function Toggle({
  checked,
  label,
  onChange,
}: {
  checked: boolean
  label: string
  onChange: (next: boolean) => void
}) {
  return (
    <label style={{ fontSize: '12px' }}>
      <input type="checkbox" checked={checked} onChange={event => onChange(event.target.checked)} /> {label}
    </label>
  )
}
